import React from "react";

export default function Divider({ className = "" }) {
  return (
    <div className={`divider-paisley py-2 ${className}`} aria-hidden="true">
      <svg width="56" height="20" viewBox="0 0 56 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 10 C 10 4, 18 16, 28 10 C 38 4, 46 16, 54 10"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
          opacity="0.6"
        />
        <circle cx="28" cy="10" r="2.5" fill="#E91E63" />
        <circle cx="14" cy="10" r="1.2" fill="#F5C518" />
        <circle cx="42" cy="10" r="1.2" fill="#1ABFB6" />
      </svg>
    </div>
  );
}
